import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ViewEmployeeVoicePageRoutingModule } from './view-employee-voice-routing.module';

import { ViewEmployeeVoicePage } from './view-employee-voice.page';
import { Camera } from '@ionic-native/camera/ngx';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ViewEmployeeVoicePageRoutingModule
  ],
  declarations: [ViewEmployeeVoicePage],
  providers:[Camera]
})
export class ViewEmployeeVoicePageModule {}
